import React from "react";
import { connect } from "react-redux";
import { Popup, Button } from "devextreme-react";
import LoadingOverlay from "../../../../Shared/LoadingOverlay";
import { openCloseModalEliminarCupo, doDeleteCupo } from "./action";

class ModalDelete extends React.PureComponent {
  handleCancel = () => {
    this.props.dispatch(openCloseModalEliminarCupo(false, {}));
  }

  handleEliminar = () => {
    this.props.dispatch(doDeleteCupo(this.props.cupo));
  }

  render() {
    return (
      <Popup
        title="Eliminar cupo"
        showCloseButton
        dragEnabled={false}
        onHiding={this.handleCancel}
        visible={this.props.isOpenModalEliminar}
        width={500}
        height={200}
        contentComponent={() => (
          <div className="modal-delete-mantenedor">
            {this.props.isLoading && <LoadingOverlay />}
            Esta acción es irreversible.
            <br />
            ¿Estás seguro de eliminar el cupo?

            <div className="button-row">
              <div>
                <Button text="Cancelar" style={{ marginRight: 5 }} onClick={this.handleCancel} />
              </div>
              <div>
                <Button text="Eliminar" type="danger" onClick={this.handleEliminar} useSubmitBehavior />
              </div>
            </div>
          </div >
        )
        }
      />
    );
  }
}

const mapStateToProps = (state) => ({
  isOpenModalEliminar: state.mantenedorCupos.isOpenModalEliminar,
  cupo: state.mantenedorCupos.cupo,
  isLoading: state.mantenedorCupos.isLoading,
});

const mapDispatchToProps = (dispatch) => ({
  dispatch: (action) => { dispatch(action); },
});

export default connect(mapStateToProps, mapDispatchToProps)(ModalDelete);
